import UnderConstruction from "./underConstruction";
import "./underConstruction.css";

function App() {
  return <UnderConstruction />;
}

export default App;
